module.exports = __webpack_public_path__ + "img/icon-add-icon-value-added.2b5a51ad.svg";